export default "__VITE_ASSET__CJnOb7sX__"